import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '@directives/directives.module';
import { ButtonModule } from '@components/button';
import { InstructionBannerComponent } from './instruction-banner.component';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    ButtonModule,
  ],
  declarations: [InstructionBannerComponent],
  exports: [InstructionBannerComponent],
})
export class InstructionBannerModule {}
